import React from 'react';
import { clsx } from 'clsx';

interface ToggleSwitchProps {
  checked: boolean;
  onChange: () => void;
  disabled?: boolean;
  label?: string;
}

export const ToggleSwitch: React.FC<ToggleSwitchProps> = ({
  checked,
  onChange,
  disabled = false,
  label,
}) => {
  return (
    <div className="flex items-center gap-2">
      {label ? <span className="sr-only">{label}</span> : null}
      <button
        type="button"
        role="switch"
        aria-checked={checked}
        aria-label={label}
        onClick={onChange}
        disabled={disabled}
        className={clsx(
          'relative inline-flex h-5 w-9 shrink-0 items-center rounded-xl p-0.5 transition-colors focus:outline-none focus:ring-2 focus:ring-blue-navbar focus:ring-offset-2',
          checked ? 'bg-blue-navbar justify-end' : 'bg-unilink-danger-strong justify-start',
          disabled ? 'cursor-not-allowed opacity-50' : 'cursor-pointer'
        )}
      >
        <span className="inline-block size-4 rounded-full bg-white shadow-sm" />
      </button>
    </div>
  );
};
